import { helper } from "@ember/component/helper"
import { heroPatterns } from "cc-frontend/utils/planbook-covers"
import { includes } from "lodash-es"

export function getPatternUrl(pattern: string): string {
  if (pattern === "DEFAULT_USER_BACKGROUND") {
    return `url('https://imgix.commoncurriculum.com/covers/patterns/hypnotize-transparent-large-75.svg')`
  }
  if (!pattern || !includes(heroPatterns, pattern)) {
    return "none"
  } else {
    return `url('https://imgix.commoncurriculum.com/covers/patterns/${pattern}')`
  }
}

export function getCoverPatternStyle(pattern: string) {
  return `--pattern-url: ${getPatternUrl(pattern)};`
}

export default helper(([pattern]: [string]) => getCoverPatternStyle(pattern))
